interface SpacesFilterButtonProps {
  onClick: () => void;
  activeFilterCount: number;
}

export function SpacesFilterButton({
  onClick,
  activeFilterCount,
}: SpacesFilterButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
      aria-label="Filter spaces"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        className="w-5 h-5"
      >
        <path
          fillRule="evenodd"
          d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 0 1 .628.74v2.288a2.25 2.25 0 0 1-.659 1.59l-4.682 4.683a2.25 2.25 0 0 0-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 0 1 8 18.25v-5.757a2.25 2.25 0 0 0-.659-1.591L2.659 6.22A2.25 2.25 0 0 1 2 4.629V2.34a.75.75 0 0 1 .628-.74Z"
          clipRule="evenodd"
        />
      </svg>
      {activeFilterCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] flex items-center justify-center bg-maven-teal-500 text-white text-xs font-medium rounded-full px-1">
          {activeFilterCount}
        </span>
      )}
    </button>
  );
}
